import { render, staticRenderFns } from "./updateuserdetail.vue?vue&type=template&id=3f1a7f5b&"
import script from "./updateuserdetail.vue?vue&type=script&lang=js&"
export * from "./updateuserdetail.vue?vue&type=script&lang=js&"
import style0 from "./updateuserdetail.vue?vue&type=style&index=0&id=3f1a7f5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports